import React from 'react'
import styled from 'styled-components/macro'
import { useLocation, Link } from 'react-router-dom'

import SidebarLayout from '../templates/SidebarLayout'
import Header from '../components/organisms/Header'
import StoreLinks from '../components/atoms/StoreLinks'
import { Button } from '../components/atoms/Button'
import { Text } from '../components/atoms/Typography'
import CoverImg from '../assets/images/Cover.jpg'
import iPhoneImg from '../assets/images/iPhone.png'

const subtitle = {
  '/prenotazione-effettuata': 'Prenotazione avvenuta correttamente!',
  '/iscrizione-effettuata':
    'Riceverai una mail di conferma direttamente sull’account che ci hai fornito.',
  '/acquisto-effettuato':
    'Ti ringraziamo, il pagamento è avvenuto correttamente.',
}

export default function Thanks() {
  const { pathname } = useLocation()

  return (
    <SidebarLayout
      HeaderComp={<Header title="Grazie" subtitle={subtitle[pathname]} />}
      hideSidebar
      smallWrapper
    >
      <article>
        <TextThanks>
          {/* <p>
            Scarica l’app per incominciare: enim ut sem viverra aliquet eget
            <a href="#">sit amet nulla facilisi morbi</a> tempus iaculis.
            Sagittis id consectetur purus ut faucibus pulvinar elementum integer
            enim.
          </p> */}
          <StoreLinks inline></StoreLinks>
        </TextThanks>
        <Figure>
          <img src={CoverImg} alt="Allenamento" />
          <img src={iPhoneImg} alt="iPhone" />
        </Figure>
        <Footer>
          <Link to="/home">
            <Button ghost>torna in home</Button>
          </Link>
        </Footer>
      </article>
    </SidebarLayout>
  )
}

const TextThanks = styled(Text)`
  @media screen and (min-width: 1024px) {
    padding-right: 30%;
  }
`

const Figure = styled.figure`
  position: relative;
  margin-top: 30px;

  img {
    width: 100%;

    &:last-child {
      position: absolute;
      top: 0;
      right: 35px;
      width: auto;
      max-width: 25%;
      transform: translateY(-50%);
    }
  }
  @media screen and (max-width: 1023px) {
    img {
      &:last-child {
        display: none;
      }
    }
  }
`

const Footer = styled.footer`
  margin-top: 24px;
  @media screen and (max-width: 1023px) {
    a {
      display: block;
      button {
        display: block;
        width: 100%;
      }
    }
  }

  @media screen and (min-width: 1024px) {
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
  }
`
